import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * O parceiro tem cancelamento de operações habilitado? (Partner.can_cancel_operations)
 *
 * Compartilhado entre Operações e Dashboard (item 23b-iii). Mantém o
 * comportamento pré-existente da página de Operações: se /auth/me não expõe o
 * campo (ou falha), assume true — o backend continua sendo o gate real (403).
 *
 * @param {boolean} enabled - só consulta quando o papel permite cancelar (admin)
 */
export default function useCanCancelOperations(enabled) {
  const [canCancelOps, setCanCancelOps] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    api.get("/auth/me").then(({ data }) => {
      if (data?.can_cancel_operations !== undefined) {
        setCanCancelOps(data.can_cancel_operations);
      } else {
        setCanCancelOps(true);
      }
    }).catch(() => setCanCancelOps(true));
  }, [enabled]);

  return canCancelOps;
}
